module.exports = {
    help: {
        pages: 6,
        pageNameFormat: "res/help/page_%d.jpg",
        priceFontName: "price-font",
        click:"res/sounds/help_click",
        pricetable: [
            { //РАКУШКА
                symbol:0,
                wins:[5,4,3],
                position:{x:131, y:55},
                offset:{width:0, height:50},
                align:'center',
                page: 1
            },
            { //ЗМЕЯ
                symbol:1,
                wins:[5,4,3],
                position:{x:131, y:248},
                offset:{width:0, height:50},
                align:'center',
                page: 1
            },
            { //BAR
                symbol:2,
                wins:[5,4,3],
                position:{x:606, y:342},
                offset:{width:0, height:51},
                align:'center'
            },
            { //УЛИТКА
                symbol:3,
                wins:[5,4,3],
                position:{x:134, y:342},
                offset:{width:0, height:51},
                align:'center'
            },
            { //SCATTER
                symbol:6,
                wins:[5,4,3],
                position:{x:607, y:248},
                offset:{width:0, height:50},
                align:'center',
                page: 1
            },
            { //БОБРЫ
                symbol:7,
                wins:[5,4,3],
                position:{x:600, y:113},
                offset:{width:0, height:51},
                align:'center'
            },
            { //ДОМ
                symbol:8,
                wins:[5,4,3],
                position:{x:607, y:55},
                offset:{width:0, height:50},
                align:'center',
                page: 1
            },
            { //SWAMPLAND2
                symbol:9,
                wins:[5,4,3,2],
                position:{x:134, y:111},
                offset:{width:0, height:48},
                align:'center'
            },
            { //ФЕЯ
                symbol:10,
                wins:[5,4,3],
                position:{x:606, y:526},
                offset:{width:0, height:51},
                align:'center'
            },
            { //ЧАСЫ
                symbol:11,
                wins:[5,4,3],
                position:{x:134, y:526},
                offset:{width:0, height:51},
                align:'center'
            }
        ]
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 14
// module chunks = 0